(async () => {
    const { Core } = await importModule('Core');
    const { NoUiSlider } = await importModule('NoUiSlider');

    customElements.define('collection-filter-price', class extends Core {
        elements = {
            slider: '[data-slider]',
            min: '[data-min]',
            max: '[data-max]',
            inputMin: '[data-input-min]',
            inputMax: '[data-input-max]'
        }

        render() {
            this._initSlider();
            this.slider.on('change', this._sliderChangeHanlder.bind(this));
        }

        _initSlider() {
            this.slider = NoUiSlider.create(this.$slider, {
                start: [
                    +this.getAttribute('current-min'),
                    +this.getAttribute('current-max')
                ],
                connect: true,
                range: {
                    min: +this.getAttribute('min'),
                    max: +this.getAttribute('max')
                }
            });
            // Add accessible names to both slider handles
            const handles = this.$slider.querySelectorAll('.noUi-handle');

            if (handles.length >= 2) {
                handles[0].setAttribute('aria-label', 'Minimum price');
                handles[1].setAttribute('aria-label', 'Maximum price');
            }            
        }

        _sliderChangeHanlder([ min, max ]) {
            this.$inputMin.value = Math.round(min);
            this.$inputMax.value = Math.round(max);
            this.publish('filter:change');
        }
        
        disconnect() {
            this.slider.destroy();
        }
    })
})();
